import { useEffect, useState } from "react";
import PropTypes from "prop-types";

const BaseStatusLabel = ({ status = "" }) => {
  const tagStyles = {
    draft: "bg-[#ECEEF1] text-[#767B86]",
    paid: "bg-[#0093FD19] text-[#0093FD]",
    cancelled: "bg-red-200 text-red-500",
    sentPatient: "bg-[#F1652119] text-[#F16521]",
    sampleCollected: "bg-[#F6DCBC] text-[#ED7B16]",
    resultSent: "bg-[#13A30B19] text-[#44B60E]",
    progress: "bg-[#BFEBD6] text-[#3A966C]",
    active: "bg-[#2EE290] text-white",
    awaitingDetails: "bg-[#FEC472] text-white-500",
  };

  const [style, setStyle] = useState("");
  const [readName, setReadName] = useState("");

  const getStatusBgColor = () => {
    switch (status) {
      case "Created":
        setStyle(tagStyles.paid);
        break;
      case "SentToPatient":
        setStyle(tagStyles.sampleCollected);
        break;
      case "AwaitingSampleCollection":
        setStyle(tagStyles.sampleCollected);
        break;
      case "AwaitingPaymentConfirmation":
        setStyle(tagStyles.sampleCollected);
        break;
      case "AwaitingPayment":
        setStyle(tagStyles.sampleCollected);
        break;
      case "Started":
        setStyle(tagStyles.sentPatient);
        break;
      case "Reached":
        setStyle(tagStyles.sentPatient);
        break;
      case "ResultUploaded":
        setStyle(tagStyles.resultSent);
        break;
      case "SampleCollected":
        setStyle(tagStyles.sentPatient);
        break;
      case "HandingOver":
        setStyle(tagStyles.progress);
        break;
      case "WithLaboratory":
        setStyle(tagStyles.progress);
        break;
      case "ResultReceived":
        setStyle(tagStyles.progress);
        break;
      case "ResultSentComplete":
        setStyle(tagStyles.resultSent);
        break;
      case "ResultSentIncomplete":
        setStyle(tagStyles.progress);
        break;
      case "Cancelled":
        setStyle(tagStyles.draft);
        break;
      case "Active":
        setStyle(tagStyles.active);
        break;
      case "AwaitingDetails":
        setStyle(tagStyles.awaitingDetails);
        break;
      case "ResultAvailable":
        setStyle(tagStyles.resultSent);
        break;
      default:
        setStyle(tagStyles.progress);
        break;
    }

    return style;
  };

  const getReadableName = () => {
    switch (status) {
      case "Created":
        setReadName("Created");
        break;
      case "SentToPatient":
        setReadName("Sent to Patient");
        break;
      case "AwaitingSampleCollection":
        setReadName("Awaiting Sample");
        break;
      case "Started":
        setReadName("Started");
        break;
      case "Reached":
        setReadName("Reached");
        break;
      case "SampleCollected":
        setReadName("Sample Collected");
        break;
      case "HandingOver":
        setReadName("In Progress");
        break;
      case "WithLaboratory":
        setReadName("In Progress");
        break;
      case "ResultReceived":
        setReadName("In Progress");
        break;
      case "ResultUploaded":
        setReadName("In Progress");
        break;
      case "ResultSentComplete":
        setReadName("Result Received");
        break;
      case "ResultSentIncomplete":
        setReadName("Result Incomplete");
        break;
      case "AwaitingPaymentConfirmation":
        setReadName("Awaiting payment confirmation");
        break;
      case "AwaitingPayment":
        setReadName("Awaiting payment");
        break;
      case "Cancelled":
        setReadName("Cancelled");
        break;
      case "Active":
        setReadName("Active");
        break;
      case "ResultAvailable":
        setReadName("Result available");
        break;
      default:
        setReadName("In Progress");
        break;
    }

    return readName;
  };
  useEffect(() => {
    getStatusBgColor();
  }, [style]);

  useEffect(() => {
    getReadableName();
  }, [readName]);

  return (
    <div
      className={`${style} py-2 flex justify-center lg:px-3 px-2 rounded-[8px] uppercase text-sm font-bold text-center w-auto transition `}
    >
      <span className="lg:text-[10px] text-base">{readName}</span>
    </div>
  );
};

BaseStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
};

export default BaseStatusLabel;
